import React, { Component } from 'react';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandoutTile } from 'web-ui-components/lib/layout/content';
import { Form } from 'react-final-form';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import Submit from '../../components/Submit';

class AlmostTherePage extends Component {
  render() {
    const { saveAlmostThereForm, getBusinessData } = this.props;
    return (
      <Form
        onSubmit={saveAlmostThereForm}
        initialValues={getBusinessData}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Content>
              {({
                almostTherePageTitle = '',
                almostThereLeadPara,
                almostThereContent1,
                almostThereContent4,
                almostThereContent6,
                almostThereLeadPara2
              }) => (
                <div>
                  <PageHeading>{almostTherePageTitle} </PageHeading>

                  <StandoutTile.Remember>
                    <StandardBody className="u-text-align-center">
                      <p>
                        {almostThereContent1}:<strong>{getCustomerNumber(getBusinessData)}</strong>
                      </p>

                      <p>
                        {almostThereContent4}:<strong>{getSortCode(getBusinessData)}</strong>
                      </p>

                      <p>
                        {almostThereContent6}:<strong>{getAccountNumber(getBusinessData)}</strong>
                      </p>
                    </StandardBody>
                  </StandoutTile.Remember>
                  <StandardBody>
                    <p>{almostThereLeadPara}</p>

                    <p>{almostThereLeadPara2}</p>
                  </StandardBody>
                  <div className="u-margin-top-2">
                    <Submit hideExit />
                  </div>
                </div>
              )}
            </Content>
          </form>
        )}
      />
    );
  }
}
AlmostTherePage.propTypes = {
  bankId: PropTypes.bankId.isRequired,
  saveAlmostThereForm: PropTypes.func.isRequired
};

const getCustomerNumber = data =>
  data && data.customer && data.customer.number ? data.customer.number : '';
const getSortCode = data =>
  data && data.account && data.account.sort_code ? data.account.sort_code : '';
const getAccountNumber = data =>
  data && data.account && data.account.account_number ? data.account.account_number : '';

export default AlmostTherePage;
